import dateUtil from "../../../utils/date"
import { t } from "../../../locale"

export const toDate = function(date) {
  return isDate(date) ? new Date(date) : null
}

export const isDate = function(date) {
  if (date === null || date === undefined) {
    return false
  }
  if (isNaN(new Date(date).getTime())) {
    return false
  }
  return true
}

export function getDaysInMonth(year, month) {
  return new Date(year, month, 0).getDate()
}

export function clearHHmmss(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate())
}

export function getDayStartTime(time) {
  const start = new Date(time)
  start.setHours(0, 0, 0, 0)
  return start.getTime()
}

export function formatDate(date, format) {
  date = toDate(date)
  if (!date) {
    return ""
  }
  return dateUtil.format(date, format || "yyyy-MM-dd")
}

export function parseDate(string, format) {
  if (string instanceof Date) {
    return string
  }

  return dateUtil.parse(string, format || "yyyy-MM-dd")
}

export const getNowData = function() {
  const now = new Date()

  return {
    year: now.getFullYear(),
    month: now.getMonth(),
    date: now.getDate(),
    day: now.getDay(),
  }
}

export const RANGE_SHORTCUTS = {
  today: {
    text: t("ui.datepicker.shortcuts.today"),
    onClick(vm) {
      const { year, month, date } = getNowData()

      const start = new Date(year, month, date)
      const end = new Date(year, month, date, 23, 59, 59)
      vm.date = [start, end]
    },
  },
  yesterday: {
    text: t("ui.datepicker.shortcuts.yesterday"),
    onClick(vm) {
      const { year, month, date } = getNowData()

      const start = new Date(year, month, date - 1)
      const end = new Date(year, month, date - 1, 23, 59, 59)
      vm.date = [start, end]
    },
  },
  thisWeek: {
    text: t("ui.datepicker.shortcuts.thisWeek"),
    onClick(vm) {
      const { year, month, date, day } = getNowData()

      const start = new Date(year, month, date - (day - 1))
      const end = new Date(year, month, date + (7 - day), 23, 59, 59)
      vm.date = [start, end]
    },
  },
  lastWeek: {
    text: t("ui.datepicker.shortcuts.lastWeek"),
    onClick(vm) {
      const { year, month, date, day } = getNowData()

      const start = new Date(year, month, date - (day + 7) + 1)
      const end = new Date(year, month, date - day)
      vm.date = [start, end]
    },
  },
  nextWeek: {
    text: t("ui.datepicker.shortcuts.nextWeek"),
    onClick(vm) {
      const { year, month, date, day } = getNowData()

      const start = new Date(year, month, date + (7 - day) + 1)
      const end = new Date(year, month, date + (7 - day) + 7)
      vm.date = [start, end]
    },
  },
  thisMonth: {
    text: t("ui.datepicker.shortcuts.thisMonth"),
    onClick(vm) {
      const { year, month } = getNowData()
      const days = getDaysInMonth(year, month + 1)

      const start = new Date(year, month, 1)
      const end = new Date(year, month, days, 23, 59, 59)
      vm.date = [start, end]
    },
  },
  lastMonth: {
    text: t("ui.datepicker.shortcuts.lastMonth"),
    onClick(vm) {
      const { year, month } = getNowData()
      const days = getDaysInMonth(year, month)

      const start = new Date(year, month - 1, 1)
      const end = new Date(year, month - 1, days, 23, 59, 59)
      vm.date = [start, end]
    },
  },
  nextMonth: {
    text: t("ui.datepicker.shortcuts.nextMonth"),
    onClick(vm) {
      const { year, month } = getNowData()
      const days = getDaysInMonth(year, month + 2)

      const start = new Date(year, month + 1, 1)
      const end = new Date(year, month + 1, days, 23, 59, 59)
      vm.date = [start, end]
    },
  },
  thisSeason: {
    text: t("ui.datepicker.shortcuts.thisQuarter"),
    onClick(vm) {
      const { year, month } = getNowData()
      const season = [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]].find(item =>
        item.includes(month)
      )
      const days = getDaysInMonth(year, season[2] + 1)

      const start = new Date(year, season[0], 1)
      const end = new Date(year, season[2], days, 23, 59, 59)
      vm.date = [start, end]
    },
  },
  lastSeason: {
    text: t("ui.datepicker.shortcuts.lastQuarter"),
    onClick(vm) {
      const { year, month } = getNowData()
      const seasons = [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]]
      let seasonIndex = seasons.findIndex(item => item.includes(month))
      const isLastYear = Boolean(seasonIndex - 1 < 0)
      seasonIndex = isLastYear ? 3 : seasonIndex - 1
      const years = isLastYear ? year - 1 : year
      const season = seasons[seasonIndex]
      const days = getDaysInMonth(years, season[2] + 1)

      const start = new Date(years, season[0], 1)
      const end = new Date(years, season[2], days, 23, 59, 59)
      vm.date = [start, end]
    },
  },
  nextSeason: {
    text: t("ui.datepicker.shortcuts.nextQuarter"),
    onClick(vm) {
      const { year, month } = getNowData()
      const seasons = [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]]
      let seasonIndex = seasons.findIndex(item => item.includes(month))
      const isNextYear = Boolean(seasonIndex + 1 > 3)
      seasonIndex = isNextYear ? 0 : seasonIndex + 1
      const years = isNextYear ? year + 1 : year
      const season = seasons[seasonIndex]
      const days = getDaysInMonth(years, season[2] + 1)

      const start = new Date(years, season[0], 1)
      const end = new Date(years, season[2], days, 23, 59, 59)
      vm.date = [start, end]
    },
  },
  thisYear: {
    text: t("ui.datepicker.shortcuts.thisYear"),
    onClick(vm) {
      const { year } = getNowData()

      const start = new Date(year, 0, 1)
      const end = new Date(year, 11, 31, 23, 59, 59)
      vm.date = [start, end]
    },
  },
  lastYear: {
    text: t("ui.datepicker.shortcuts.lastYear"),
    onClick(vm) {
      const { year } = getNowData()

      const start = new Date(year - 1, 0, 1)
      const end = new Date(year - 1, 11, 31, 23, 59, 59)
      vm.date = [start, end]
    },
  },
}
